import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PreferencesService } from '../../../../../modules/preferences/preferences.service';
import { FavouriteDialogService } from '../../../favourite-dialog/favourite-dialog.service';
import { EQUIPMENTVM, GenericIdNameVMforEQUIPMENT, GETCrackSchematicVM, SchematicDataVM } from '../../../setup-implement/setup-implement.model';
import { EquipmentImplementDetails } from '../../dashboard.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-crack-view-dialog',
  templateUrl: './implement-crack-view-dialog.component.html',
  styleUrls: ['./implement-crack-view-dialog.component.scss']
})
export class ImplementCrackViewDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ImplementCrackViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _favouritesService: FavouriteDialogService,
    private _router: Router,
    private readonly _pref: PreferencesService,
    private _sanitizer: DomSanitizer,) { }


    implementTypeListForTable: GenericIdNameVMforEQUIPMENT;
    ImplementID:number
    Name:string=""
    EquipmentList:EQUIPMENTVM[]=[]
    EquipmentListFiltred:EQUIPMENTVM[]=[]
    implementTypeListForTable_: GenericIdNameVMforEQUIPMENT[]=[]
    selectedTab
   
    EquipmentdetailsList :EquipmentImplementDetails;
      loading: boolean = false;
  ngOnInit() {
    this.implementTypeListForTable= this.data.implementTypeListForTable
    this.EquipmentdetailsList=this.data.EquipmentdetailsList
    this.ImplementID=this.implementTypeListForTable.Id;
    this.Name=this.implementTypeListForTable.Name
    console.log(this.implementTypeListForTable)
    
    this. GetAllEquipmentsforImplement();
    this.GetDetailsedCompartmentView()
    
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }


  GetDetailsedCompartmentView(){
    this._favouritesService.GetDetailsedCompartmentView_(this.ImplementID).subscribe(res=>{
      console.log("implement serials",res)
     this.implementTypeListForTable_=res
     
this.GetSchematicDataForImplement_Dashboard();
    })
  }

  GetAllEquipmentsforImplement(){
    this._favouritesService.GetAllEquipmentsforImplement(this.EquipmentdetailsList,this.ImplementID).subscribe(res=>{
      this.EquipmentList=res
     
     // console.log("EquipmentdetailsList", this.EquipmentdetailsList)
    //  this.EquipmentdetailsList.Details.map(e=>{
    //   this.EquipmentList= this.EquipmentListFiltred.filter(x=>x.euipmentID== e.EquipmentId)
    //  })

    
     console.log("EquipmentList", this.EquipmentList)
    
      //console.log("before", this.implementTypeListForTable_)
     
    })
  }

  showValue(EquipmentId,im:GenericIdNameVMforEQUIPMENT){
  //   console.log("yyyyyy",im.Equipment,im.isPrint, im.Name, EquipmentId)
  
    var isContains= im.Equipment.filter(x=>x.euipmentID!=null && x.euipmentID== EquipmentId);
  // console.log("isContains",isContains)
    if(isContains.length>0){
        im.isPrint=true
    }
  
    else  im.isPrint=false
   // console.log("tttyyyy",im.isPrint)
      return true;
      }
  

      
NavigateCrackRegister(equipmentid:number) { 
  if (equipmentid) {
    // this._router.navigate(['/implementdetails/' + im.Id, '_blank', { selectedTab: 3, }]);   

  // window.open('/dfi-implementdetails/' + equipmentid, '_blank');

  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/dfi-implementdetails', equipmentid]);
    }else{             
      window.open('/dfi-implementdetails/' + equipmentid, '_blank');
     
    }
});
  //this._router.navigate(['/implementdetails/' + im.Id]);

  } 
}


EquipmentID:number[]=[]
implementID:number[]=[]
schematicList: SchematicDataVM[] = [];
GetSchematicDataForImplement_Dashboard(){

  for(var i=0 ;i<this.EquipmentdetailsList.Details.length; i++){
    this.EquipmentID.push(this.EquipmentdetailsList.Details[i].EquipmentId)
  }
  for(var i=0 ;i<this.implementTypeListForTable_.length; i++){
    this.implementID.push(this.implementTypeListForTable_[i].Id)
  }

  var params: GETCrackSchematicVM = {
    EquipmentID:this.EquipmentID,
    implementID:this.implementID
    
};
  


  this._favouritesService.GetSchematicDataForImplement_Dashboard(params).subscribe(res=>{
this.schematicList=res
  })
}

getImage(image: string) {
  // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

} 
showSchematic: boolean = false;
  schematicPositionX: number;
  schematicPositionY: number;
  draggableSchematicTitle: string = "Schematic";
  prevMouseX: number;
  prevMouseY: number;
  selectedSchematic: SchematicDataVM;
  currentStep: number = 2;
  openSchematicWindow(schematic, imgOrSchematic) {
  
    this.schematicPositionX = 500;
    this.schematicPositionY = 450;
    this.prevMouseX = 0;
    this.prevMouseY = 0;
    this.selectedSchematic = schematic;
    this.showSchematic = true;
    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
  }

  onCloseSchematicWindow(e) {
    this.showSchematic = false;
    // this.loadObservationPointsForImplement();
    // this.loadObservationLists();
  }

  onSaveObservation(e) {
   // this.loadObservationPointsForImplement();
    // this.loadImplementSchematics();
   // this.loadObservationLists();
}
}
